module.exports = __webpack_public_path__ + "static/img/cover-03.c249ac42.png";